class BaseElement2 extends HTMLElement {
  constructor() {
    super()
    this._connected = false
    /** @type {AbortController} */
    this._ac = /** @type {any} */ (null)
  }

  async connectedCallback() {
    this._connected = true
    await Promise.resolve()
    if (!this._connected) return

    this._ac && !this._ac.signal.aborted && this._ac.abort()
    this._ac = new AbortController()

    /** @type {any} */
    let x = this.mount()
    if (x instanceof Promise) {
      x = await x
    }

    if (x !== false) {
      this._aftermount()
    }
  }

  mount() {}
  unmount() {}

  _aftermount() {
    this.setAttribute('hydrated', 'true')
  }
  _afterunmount() {
    this.setAttribute('hydrated', 'false')
  }

  async disconnectedCallback() {
    this._connected = false
    await Promise.resolve()
    if (this._connected) return

    this._ac && !this._ac.signal.aborted && this._ac.abort()
    // @ts-expect-error
    this._ac = null
    this.unmount()
    this._afterunmount()
  }
}

/* prettier-ignore */
const STATUS_DESCRIPTIONS = {
  "Initial Processing Complete": "During this time, we will order all needed materials, submit the design to our jewelry casting team, and complete royalty payments to your university.",

  "Seal Casting": "During this timeframe, our casting team will cast your uniquely designed ring or pendant. Once the ring or pendant and seal are cast, we will send both pieces to the Final Assembly with our master jewelers.",

  "Ring Casting": "During this timeframe, our casting team will cast your uniquely designed ring or pendant. Once the ring or pendant and seal are cast, we will send both pieces to the Final Assembly with our master jewelers.",

  "Final Assembly": "During this production stage, the seal is welded to your ring/pendant, all necessary stones are set in the ring/pendant, and the final polishing is completed.",

  "Quality Inspection": "During this production stage, your ring or pendant will undergo quality checks, and if you purchased it, we will complete the engraving. Once complete, we will contact you to let you know your ring or pendant is ready for pickup or shipping.",

  "Engraving": "During this time, we will work on precisely engraving your custom information.",

  "Quality Control Checks & Engraving": "During this time, we will perform our final quality checks, polishing, and cleaning. If you purchased engraving, this will also be completed during this final step",

  "Complete": "Your order is ready.",

  "Casting & Setting Seal": "During this timeframe, our casting team will start casting your school's seal, which will be added to our ring/pendant during the Final Assembly Stage."
}
for (const [key, value] of Object.entries(STATUS_DESCRIPTIONS)) {
  const slug = slugify(key)
  delete STATUS_DESCRIPTIONS[key]
  STATUS_DESCRIPTIONS[slug] = value
}

class XOrderStatusWidget extends BaseElement2 {
  static _tag = 'x-order-status-widget'
  static _STATUS_DESCRIPTIONS = STATUS_DESCRIPTIONS

  constructor() {
    super()
  }

  mount() {
    this.els = {
      resultContainer: this.querySelector('[data-order-result]'),
      form: this.querySelector('form'),
    }
    this.shop_handle = this.getAttribute('shop-handle') || ''
    this.setAttribute('data-fetch-status', 'idle')
    this.els.form.setAttribute('data-fetch-status', 'idle')

    this.els.form.addEventListener(
      'submit',
      async (e) => {
        e.preventDefault()
        e.stopPropagation()
        const form = this.els.form
        const orderNumber = form.elements.namedItem('order_number').value
        const emailOrPhone = form.elements.namedItem('email_or_phone').value
        if (!orderNumber || !emailOrPhone) {
          return
        }

        this.setAttribute('data-fetch-status', 'idle pending')
        this.els.form.setAttribute('data-fetch-status', 'idle pending')

        let errMsg = ''
        let generatedHtml = ''

        const data = await this.fetchOrderData({
          order_number: orderNumber,
          email_or_phone: emailOrPhone,
        })
        const totalSteps = data?.workflow_steps?.length || 0
        const hasOrder = data?._order

        if (hasOrder) {
          generatedHtml = generateHtml(data)

          if (totalSteps === 0) {
            errMsg = 'We are unable to find any update on this order.'
          }
        } else {
          errMsg = 'Order not found.'
        }

        if (errMsg) {
          generatedHtml += `<p class="error-message">${errMsg}</p>`
        }

        this.els.resultContainer.innerHTML = generatedHtml
        const status = `idle ${errMsg ? 'error' : 'success'}`
        this.setAttribute('data-fetch-status', status)
        this.els.form.setAttribute('data-fetch-status', status)
      },
      { signal: this._ac.signal }
    )
  }

  /**
   *
   * @param {{ order_number: string, email_or_phone: string}} input
   * @returns
   */
  async fetchOrderData(input) {
    let order_number = input.order_number
    if (order_number && typeof order_number === 'string') order_number = order_number.replace('#', '')
    const result = await fetch(
      `https://cedarsphere-workers.ziad-388.workers.dev/api/w3-order-status?shop=${this.shop_handle}&order_number=${order_number}&email_or_phone=${input.email_or_phone}`,
      {
        method: 'GET',
        headers: {
          accept: 'application/json',
          // "Content-Type": "application/json",
        },
        // body: JSON.stringify(input),
      }
    ).then((r) => r.json())
    const data = result?.data
    if (data) {
      const hasOrder = !!data._order?.created_at

      if (hasOrder && (!data.workflow_steps || data.workflow_steps.length === 0)) {
        data.workflow_steps = []
      }
    }
    return result?.data ?? null

    return null

    return {
      _order: {
        id: 123456789,
        name: '#1004',
        created_at: '2023-01-01T17:13:35-05:00',
        total_price: '104.25',
        currency: 'USD',
      },
      order_date: '2023-01-01',
      order_name: '#1004',
      order_total: '$104.25',

      current_status_id: 98765,
      current_status_name: 'Pending',
      current_status_name_public: 'Your order is pending',
      due_date: '2024-01-01',
      last_updated: '2023-01-02',
      updated_by: 'Susan Smith',
      order_id: 123,
      private_note: null,
      public_note: null,
      workflow_id: 29,
      workflow_name: 'Internal workflow',
      workflow_steps: [
        {
          display_order: 0,
          status_id: 40267,
          status_name: 'Received',
          status_name_public: 'Received',
          step_status: 'complete',
        },
        {
          display_order: 1,
          status_id: 353667,
          status_name: 'in-production',
          status_name_public: 'In Production',
          step_status: 'current',
        },
        {
          display_order: 2,
          status_id: 456456,
          status_name: 'shipping',
          status_name_public: 'Shipped',
          step_status: 'upcoming',
        },
      ],
    }
  }
}

if (!customElements.get(XOrderStatusWidget._tag)) {
  customElements.define(XOrderStatusWidget._tag, XOrderStatusWidget)
}

// --------------------------------------------------

// https://codepen.io/NaveenPantra/pen/gOONZXo?editors=1010
function generateHtml(data) {
  const workflow_steps = data?.workflow_steps || []
  return /* HTML */ `<section class="w3-order-status-custom">
    <figure>
      <img
        src="https://photos.melorra.com/fit-in/1024x1024/dev/catalogue/images/ET/OPT/580/C16PET09F_P_580.jpg"
        alt=""
        hidden
      />
      <figcaption>
        <h4>Order ${data._order.name}</h4>
        <div class="fig-subcaption">${data._order.customerName}</div>
        <div class="fig-subcaption">$ ${data._order.total_price}</div>
      </figcaption>
    </figure>
    <div class="order-track">
      <div class="order-track-step" data-step-status="complete">
        <div class="order-track-status">
          <span class="order-track-status-dot"></span>
          <span class="order-track-status-line"></span>
        </div>
        <div class="order-track-text">
          <p class="order-track-text-stat">Order Received</p>
          <span class="order-track-text-sub">${formatDate(data._order.created_at, true)}</span>
        </div>
      </div>

      ${workflow_steps
        .map((step, i) => {
          const name = step.status_name_public
          const slug = slugify(name)

          let ariaMsg = `Step ${i + 1} of ${workflow_steps.length}.`
          if (step.step_status === 'current') {
            const isLast = i === workflow_steps.length - 1
            ariaMsg += isLast
              ? ` Your order has been completed.`
              : ` Your order is at this step now.`
          }

          const description = STATUS_DESCRIPTIONS[slug] || ''
          return /* HTML */ `<div class="order-track-step" data-step-status="${step.step_status}">
            <div class="order-track-status">
              <span class="order-track-status-dot"></span>
              <span class="order-track-status-line"></span>
            </div>
            <div class="order-track-text">
              <p class="order-track-text-stat">${step.status_name_public}</p>
              <span class="visually-hidden">${ariaMsg}</span>

              ${step.step_status === 'current'
                ? `<span class="order-track-text-sub">${formatDate(data.last_updated)}</span>`
                : ''}
              ${description
                ? `<span class="order-track-text-sub order-track-text-description">${description}</span>`
                : ''}
              ${step.step_status === 'upcoming' && i === data.workflow_steps.length - 1
                ? `<span class="order-track-text-sub">Your order is <strong>ESTIMATED</strong> to be completed on ${formatDate(
                    addDays(new Date(data._order.created_at), 10 * 7) // 10 weeks
                  )}</span>`
                : ''}
            </div>
          </div>`
        })
        .join('')}
    </div>
  </section>`
}

/* prettier-ignore */
function nth(d) {
  if (d > 3 && d < 21) return 'th'
  switch (d % 10) {
    case 1:  return "st"
    case 2:  return "nd"
    case 3:  return "rd"
    default: return "th"
  }
}

/* prettier-ignore */
function formatDate(date, showTime = false) {
  if (typeof date === 'string') {
    date = new Date(date)
  }

  if (!(date instanceof Date)) {
    throw new Error('Invalid date. Please provide a valid date')
  }

  const d = date.getDate()

  // 22nd May, 2012
  return `${d + nth(d)} ${date.toLocaleString('default', { month: 'long' })}, ${date.getFullYear()}`
}

/**
 *
 * @param {Date} date
 * @param {number} days
 */
function addDays(date, days) {
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

function slugify(str) {
  return str
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}
